import { Component, ojs, app } from "modular-openscriptjs";
import { eParse, isMobile, cleanDispose } from "../../helpers";
import { tool, dom } from "../../fotastart";
import { _UNIQUE_ID_ } from "../../declarations";

const h = app("h");
const $e = app("$e");

export default class QRCodeModal extends Component {
	modal = null;

	render(...args) {
		return h.div(
			{
				class: "d-none",
			},
			...args
		);
	}

	async showForm(ed, event) {
		let { message } = eParse(ed);

		if (this.modal) {
			cleanDispose(this.modal);
		}

		let id = `${_UNIQUE_ID_}`;
		let modalId = `qr-modal-${id}`;

		let content = h.div(
			{
				class: "modal-content border-0 shadow-lg rounded-4 overflow-hidden",
			},
			// Header
			h.div(
				{
					class: "modal-header border-0 pb-0 pt-4 px-4 d-flex justify-content-between align-items-center",
				},
				h.h5(
					{ class: "modal-title fw-bold text-secondary" },
					message.get("title", "Scan QR Code")
				),
				h.button({
					class: "btn-close bg-light rounded-circle p-2",
					"data-bs-dismiss": "modal",
					aria_label: "Close",
				})
			),
			// Body
			h.div(
				{ class: "modal-body p-4 text-center" },
				h.div({
					id: `qr-code-${id}`,
					class: "d-inline-block p-3 bg-white rounded-4 shadow-sm border border-light-subtle mb-3",
					style: "min-width: 200px; min-height: 200px;",
				}),
				h.p(
					{ class: "text-muted small mb-0" },
					"Scan this code with your mobile device"
				)
			),
			// Footer
			h.div(
				{
					class: "modal-footer border-0 px-4 pb-4 pt-0 justify-content-center",
				},
				h.button(
					{
						id: `download-btn-${id}`,
						class: "btn btn-dark rounded-pill px-4 py-2 w-100 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2",
					},
					h.i({ class: "fas fa-download" }),
					"Download Image"
				)
			)
		);

		this.modal = tool.plainModal(content, { id: modalId });
		this.modal.show();

		// Render QR Code logic
		setTimeout(() => {
			this.renderQR(id, message);
		}, 150); // Small delay to ensure modal is in DOM
	}

	renderQR(id, message) {
		let vw = Math.max(
			document.documentElement.clientWidth || 50,
			window.innerWidth || 50
		);
		let vh = Math.max(
			document.documentElement.clientHeight || 50,
			window.innerHeight || 50
		);

		let p = message.get("data");
		let path = p;

		if (!app("router").isQualifiedUrl(p)) {
			if (p[0] != "/") p = `/${p}`;
			path = `${app("router").url().origin}/app${p}`;
		}

		const size = Math.min(Math.min(vw, vh) * 0.6, 300); // Responsive size cap

		QrCreator.render(
			{
				text: path,
				radius: "0", // Sharper for scanability
				ecLevel: "H",
				fill: "#000000",
				background: "#ffffff",
				size: size,
			},
			dom.id(`qr-code-${id}`)
		);

		// Download Listener
		let downloadBtn = dom.id(`download-btn-${id}`);
		if (downloadBtn) {
			downloadBtn.addEventListener("click", () =>
				this.downloadQR(id, message)
			);
		}
	}

	downloadQR(id, message) {
		let originalCanvas = dom.get("canvas", dom.id(`qr-code-${id}`));
		if (!originalCanvas) return;

		var originalContext = originalCanvas.getContext("2d");
		var padding = isMobile() ? 20 : 40;

		var newWidth = originalCanvas.width + 2 * padding;
		var newHeight = originalCanvas.height + 2 * padding;

		var paddedCanvas = document.createElement("canvas");
		paddedCanvas.width = newWidth;
		paddedCanvas.height = newHeight;
		var paddedContext = paddedCanvas.getContext("2d");

		paddedContext.fillStyle = "white";
		paddedContext.fillRect(0, 0, newWidth, newHeight);
		paddedContext.drawImage(originalCanvas, padding, padding);

		var pngDataUrl = paddedCanvas.toDataURL("image/png", 100);

		let a = h.a({
			download: `${message.get("title", "qrcode")}.png`,
			href: pngDataUrl,
			class: "d-none",
			parent: dom.id(`qr-code-${id}`),
		});

		a.click();
		a.remove();
	}

	$$qr = {
		needs: {
			code: (ed, event) => this.showForm(ed, event),
		},
	};

	cleanUp() {
		super.cleanUp();
		if (this.modal) cleanDispose(this.modal);
	}
}

ojs(QRCodeModal);
